import React from "react";
import * as S from "./styles";

export const Slide2: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.Title>
          Foi-se o tempo em que precisávamos olhar para fora do Brasil para
          apreciar o melhor da música pop.{" "}
        </S.Title>
        <S.Text>
          <p>
            O cenário do gênero em território nacional está cada vez mais quente
            e nós temos a quem agradecer. Pabllo Vittar, Luísa Sonza e Gloria
            Groove são, atualmente, as três divas que estão no topo musical com
            hits que fazem a gente dançar ainda que em tempos sombrios. Com uma
            mistura de ritmos e estilos, abraçando o melhor que a cultura
            brasileira tem a oferecer de norte a sul do país, nosso pop é
            original, múltiplo e inovador – assim como essas cantoras
            poderosíssimas que estrelam a ELLE View. Desta vez nos juntamos ao
            Amazon Music para celebrar o mês do pop na plataforma, dando
            destaque aos artistas do gênero que representam a cultura local com
            a playlist superespecial Pop Brasil.
          </p>

          <p>
            Neste ano, com Batidão tropical (2021), Pabllo fez todo mundo se
            apaixonar pelo brega do Norte e do Nordeste, com sua leitura
            futurista do ritmo que ouviu enquanto crescia. Ninguém passou impune
            por músicas como “Ama, sofre, chora” e “Triste com T”. Aliás, quão
            genial foi a popstar ao inventar um casamento e uma lua de mel
            fracassada como background desses dois clipes, respectivamente? A
            drag queen maranhense já coleciona colaborações internacionais com
            artistas como Charli XCX, Diplo e Major Lazer e tem ganhado cada vez
            mais visibilidade lá fora. Quem mais amou o remix forró de “Fun
            tonight” feito por ela para o Dawn of Chromatica (2021) de Lady
            Gaga? Como bem disse o meme, dessa vez Pabllo realmente foi longe
            demais – agora é só esperar ela dominar o mundo de vez.
          </p>
        </S.Text>
      </S.Content>
    </S.Container>
  );
};
